import { useState, useEffect } from "react";
import PrimeSharkAnimated from "../../../assets/images/prime_shark_animated.gif";
import "./noDataFound.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import aiSharkAnimation from "../../../assets/aiShark.json";
const AIIcon = () => (
  <svg viewBox="0 0 22 22" fill="none" width="18" height="18">
    <style>{`
      .star-path { animation: starPulse 1.8s ease-in-out infinite; transform-origin: 11px 11px; }
      .star-sm { animation: starPulse 1.8s ease-in-out infinite 0.4s; transform-origin: 17px 5px; }
      @keyframes starPulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.6;transform:scale(0.85)} }
    `}</style>
    <path
      className="star-path"
      d="M11 2L12.8 8.2L19 11L12.8 13.8L11 20L9.2 13.8L3 11L9.2 8.2L11 2Z"
      stroke="#6fb64c"
      strokeWidth="1.4"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      className="star-sm"
      d="M17 2L17.9 4.8L21 6L17.9 7.2L17 10L16.1 7.2L13 6L16.1 4.8L17 2Z"
      stroke="#26a699"
      strokeWidth="1.2"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Profile + Add icon - matches brand icon grid style
const ProfileAddIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <style>{`
      .profile-add { animation: iconPop 0.5s cubic-bezier(0.34,1.56,0.64,1) forwards; }
      @keyframes iconPop { from{transform:scale(0.7);opacity:0} to{transform:scale(1);opacity:1} }
    `}</style>
    <g className="profile-add">
      <circle cx="10" cy="8" r="3.5" stroke="white" strokeWidth="1.6" />
      <path
        d="M3 20C3 16.5 6.1 14 10 14"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="18" cy="17" r="5" fill="#6fb64c" />
      <path
        d="M18 14.5V17M18 17V19.5M18 17H15.5M18 17H20.5"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

// Arrow icon
const ArrowRight = () => (
  <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
    <path
      d="M4 10h12M11 5l5 5-5 5"
      stroke="white"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TypewriterText = ({ text, onDone }: any) => {
  const [displayed, setDisplayed] = useState("");
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (idx < text?.length) {
      const t = setTimeout(() => {
        setDisplayed((p) => p + text[idx]);
        setIdx((i) => i + 1);
      }, 16);
      return () => clearTimeout(t);
    } else {
      onDone && onDone();
    }
  }, [idx, text]);

  return (
    <span>
      {displayed}
      <span
        style={{
          opacity: idx < text?.length ? 1 : 0,
          animation: "cur 0.7s step-end infinite",
        }}
      >
        |
      </span>
    </span>
  );
};

export default function PrimeSharkNoRecord({
  text,
  titleMsg,
  showButton,
}: any) {
  const [show, setShow] = useState(true);
  const [typing, setTyping] = useState(false);
  const [btnReady, setBtnReady] = useState(false);
  const [closing, setClosing] = useState(false);
  let navigate = useNavigate();
  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );
  let account_type = activeLoginTypes?.account_type;
  let login_type = activeLoginTypes?.loginType;
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
      setTimeout(() => setTyping(true), 500);
    }, 300);
  }, []);

  const close = () => {
    setClosing(true);
    // setTimeout(() => setShow(false), 280);
    window.history.back();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f6f7",
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        padding: "20px",
      }}
    >
      {show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(58,65,84,0.55)",
            backdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
            animation: closing
              ? "fadeOut 0.28s ease forwards"
              : "fadeIn 0.3s ease forwards",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              width: "100%",
              maxWidth: "460px",
              overflow: "hidden",
              boxShadow:
                "0 24px 64px rgba(58,65,84,0.18), 0 4px 16px rgba(111,182,76,0.12)",
              animation: closing
                ? "popDown 0.28s ease forwards"
                : "popUp 0.42s cubic-bezier(0.34,1.4,0.64,1) forwards",
              position: "relative",
            }}
          >
            {/* Top green bar */}
            <div
              style={{
                height: "4px",
                background: "linear-gradient(90deg, #6fb64c, #26a699)",
              }}
            />

            {/* Close button */}
            <button
              onClick={close}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                background: "#f0f2f5",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#7c7c7c",
                fontSize: "18px",
                transition: "all 0.2s",
                lineHeight: 1,
                fontFamily: "inherit",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e8f5e0";
                e.currentTarget.style.color = "#6fb64c";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#f0f2f5";
                e.currentTarget.style.color = "#7c7c7c";
              }}
            >
              ×
            </button>

            <div style={{ padding: "32px 32px 28px" }}>
              {/* Shark icon centered */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #f0f8e8 0%, #e8f5f4 100%)",
                    border: "2px solid #dff0d7",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow:
                      "0 10px 30px rgba(111,182,76,0.18), inset 0 2px 8px rgba(255,255,255,0.7)",
                    overflow: "visible",
                  }}
                >
                  {/* glow */}
                  <div
                    style={{
                      position: "absolute",
                      inset: "-8px",
                      borderRadius: "50%",
                      background:
                        "radial-gradient(circle, rgba(111,182,76,0.18), transparent 70%)",
                      animation: "popFloat  2s ease-in-out infinite",
                    }}
                  />

                  {/* shark image */}
                  <Lottie
                    animationData={aiSharkAnimation}
                    loop={true}
                    style={{
                      width: 200,
                      height: 200,
                      position: "absolute",
                      top: "-18px",
                      zIndex: 5,
                    }}
                  />
                </div>
              </div>

              {/* Status badge */}
              <div style={{ textAlign: "center", marginBottom: "6px" }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#fef2f2",
                    border: "1px solid #fecaca",
                    borderRadius: "20px",
                    padding: "4px 12px",
                    fontSize: "11px",
                    fontWeight: "600",
                    color: "#dc2626",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                  }}
                >
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      background: "#dc2626",
                      display: "inline-block",
                      animation: "pulse 1.4s ease infinite",
                    }}
                  />
                  {titleMsg}
                </span>
              </div>

              {/* Heading */}
              {/* {titleMsg && (
                <h2
                  style={{
                    textAlign: "center",
                    margin: "0 0 6px",
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#3A4154",
                    letterSpacing: "-0.02em",
                    lineHeight: 1.25,
                  }}
                >
                  {titleMsg}
                </h2>
              )} */}
              {/* <p
                style={{
                  textAlign: "center",
                  margin: "0 0 22px",
                  fontSize: "13px",
                  color: "#7c7c7c",
                  lineHeight: 1.5,
                }}
              >
                Your current profile settings didn't match any investors.
              </p> */}

              {/* AI insight panel */}
              <div
                style={{
                  background: "#fafffe",
                  border: "1.5px solid #d4ede8",
                  borderRadius: "14px",
                  padding: "18px 18px 16px",
                  marginBottom: "22px",
                  position: "relative",
                  minHeight: "110px",
                }}
              >
                {/* AI label */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                    marginBottom: "11px",
                  }}
                >
                  <AIIcon />
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: "700",
                      color: "#26a699",
                      letterSpacing: "0.1em",
                      textTransform: "uppercase",
                    }}
                  >
                    AI Insight
                  </span>
                  <div
                    style={{
                      flex: 1,
                      height: "1px",
                      background:
                        "linear-gradient(90deg, #d4ede8, transparent)",
                    }}
                  />
                </div>

                <p
                  style={{
                    margin: 0,
                    fontSize: "13.5px",
                    lineHeight: "1.7",
                    color: "#545454",
                    fontFamily: "'Helvetica Neue', Helvetica, sans-serif",
                  }}
                >
                  {typing ? (
                    <TypewriterText
                      text={text}
                      onDone={() => setTimeout(() => setBtnReady(true), 200)}
                    />
                  ) : (
                    ""
                  )}
                </p>

                {/* Decorative corner */}
                <div style={{ position: "absolute", bottom: 10, right: 12 }}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    opacity="0.15"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="8"
                      stroke="#26a699"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M10 6v4l3 1.5"
                      stroke="#26a699"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>

              {/* CTA Button */}
              <div
                style={{
                  opacity: btnReady ? 1 : 0,
                  transform: btnReady ? "translateY(0)" : "translateY(8px)",
                  transition: "all 0.38s cubic-bezier(0.34,1.3,0.64,1)",
                }}
              >
                {showButton && (
                  <button
                    style={{
                      width: "100%",
                      padding: "14px 20px",
                      background: "linear-gradient(135deg, #6fb64c, #5ea33d)",
                      border: "none",
                      borderRadius: "12px",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      fontFamily: "inherit",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      letterSpacing: "0.01em",
                      boxShadow: "0 4px 16px rgba(111,182,76,0.35)",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 24px rgba(111,182,76,0.45)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 16px rgba(111,182,76,0.35)";
                    }}
                    onClick={() => {
                      navigate(`/${login_type}/${account_type}/my-profile`);
                    }}
                  >
                    <ProfileAddIcon />
                    Update Your Profile to Improve Matches
                    <ArrowRight />
                  </button>
                )}

                {/* Divider + dismiss */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "14px",
                  }}
                >
                  <div
                    style={{ flex: 1, height: "1px", background: "#e8eaed" }}
                  />
                  <button
                    onClick={close}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "12px",
                      color: "#7c7c7c",
                      fontFamily: "inherit",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = "#6fb64c")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = "#7c7c7c")
                    }
                  >
                    Dismiss
                  </button>
                  <div
                    style={{ flex: 1, height: "1px", background: "#e8eaed" }}
                  />
                </div>
              </div>
            </div>

            {/* Bottom brand strip */}
            <div
              style={{
                background: "#3A4154",
                padding: "10px 32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontSize: "11px",
                  color: "rgba(255,255,255,0.5)",
                  letterSpacing: "0.04em",
                }}
              >
                PrimeShark
              </span>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "#6fb64c",
                    animation: "pulse 2s ease infinite",
                  }}
                />
                <span
                  style={{
                    fontSize: "11px",
                    color: "rgba(255,255,255,0.5)",
                    letterSpacing: "0.04em",
                  }}
                >
                  AI Powered
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
@keyframes fadeIn {
  from {opacity:0}
  to {opacity:1}
}

@keyframes fadeOut {
  from {opacity:1}
  to {opacity:0}
}

@keyframes popUp {
  from {opacity:0; transform:scale(.92) translateY(24px)}
  to {opacity:1; transform:scale(1) translateY(0)}
}

@keyframes popDown {
  from {opacity:1; transform:scale(1)}
  to {opacity:0; transform:scale(.94) translateY(16px)}
}

@keyframes pulse {
  0%,100% {opacity:1; transform:scale(1)}
  50% {opacity:.5; transform:scale(.85)}
}

@keyframes cur {
  0%,100% {opacity:1}
  50% {opacity:0}
}

/* Shark Floating */
@keyframes popFloat {
  0%,100% {
    transform: translateY(0px) scale(1);
  }
  50% {
    transform: translateY(-8px) scale(1.06);
  }
}

/* Glow */
@keyframes pulseGlow {
  0%,100% {
    transform: scale(1);
    opacity: .6;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
  }
}

/* Optional Rotate Ring */
@keyframes spinRing {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}
`}</style>
    </div>
  );
}
